import { IClauseStats } from "@/api";
import { Paper, useMediaQuery, useTheme } from "@mui/material";
import { axisClasses, BarChart } from "@mui/x-charts";

const chartSetting = {
    yAxis: [
        {
            label: "Downvotes",
        },
    ],
    series: [
        {
            dataKey: "down_votes",
            label: "Clause Identification Downvotes",
            valueFormatter,
        },
    ],
    sx: {
        [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
            transform: "translateX(-10px)",
        },
    },
};

function valueFormatter(value: number | null) {
    if (value === null) return "N/A";
    return `${value} Downvote(s)`;
}

interface IProps {
    clauses: IClauseStats[];
}

export const ClauseDownvotes = ({ clauses }: IProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

    // format to match dataset structure
    const formattedClauses = clauses.map((clause) => ({
        name: clause.name,
        down_votes: clause.down_votes,
    }));

    return (
        <Paper
            variant="outlined"
            sx={{ height: "100%", width: "100%", px: 5.125, pt: 2.5 }}
        >
            <BarChart
                dataset={formattedClauses}
                colors={["#AAAAAA"]}
                xAxis={[
                    {
                        scaleType: "band",
                        dataKey: "name",
                        tickLabelStyle: {
                            angle: -45,
                            fontSize: 12,
                        },
                        height: 100,
                    },
                ]}
                slotProps={{
                    tooltip: { trigger: "item" },
                }}
                height={isMobile ? 350 : 450}
                {...chartSetting}
            />
        </Paper>
    );
};
